import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { environment } from '@env/environment';
import { ENV_PROVIDER_TOKEN, PortalLibModule, portalNgrxEffects, portalNgrxReducers } from '@le_cedre/portal-lib';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from 'angularx-social-login';
import { NgxCaptchaModule } from 'ngx-captcha';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { HttpLoaderFactory, metaReducers } from './app/app.module';
import { PortalEnvironnementProvider } from './app/shared/environnement-provider';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            AppRoutingModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient],
                },
            }),
            PortalLibModule,
            ReactiveFormsModule,
            FormsModule,
            MatButtonModule,
            SatPopoverModule,
            MatProgressSpinnerModule,
            NgxCaptchaModule,
            SocialLoginModule,
            MatIconModule,
            StoreModule.forRoot(portalNgrxReducers, { metaReducers }),
            !environment.production ? StoreDevtoolsModule.instrument({ connectInZone: true }) : [],
            EffectsModule.forRoot([...portalNgrxEffects])
        ),
        { provide: ENV_PROVIDER_TOKEN, useExisting: PortalEnvironnementProvider },
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(environment.commonOptions.googleClientId),
                    },
                ],
            } as SocialAuthServiceConfig,
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
    ],
}).catch((err) => console.error(err));
